// -- Endpoints --

// Dictionaries
export const GET_DICTIONARIES = 'api/dictionaries/agent';
export const GET_SUPERVISOR_DICTIONARIS = '/api/dictionaries/user';
export const GET_SUPERVISOR_DICTIONARIS_REGION = '/api/dictionaries/supervisor';

export default GET_DICTIONARIES;
